import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';

import { DeviceClaimingApiService } from '@shure/cloud/device-management/devices/data-access';
import {
	PrismDialogRef,
	PrismStepper,
	PrismStepperComponent,
	PrismStepperDialogComponent
} from '@shure/prism-angular-components';
import {
	provideStepRouter,
	StepRouter,
	StepRouterContentOutletComponent,
	StepRouterFooterOutletComponent
} from '@shure/shared/angular/ui/components/step-router';

import { AddDevicesDialogService } from '../../../services/add-devices-dialog.service';
import { QrCodeClaimingService } from '../../../services/qr-code-claiming.service';

import { Step1HowToFindConfig } from './step1-how-to-find/step1-how-to-find.config';
import { Step2DiscoverDevicesConfig } from './step2-scanning/step2-discover-devices.config';
import { Step3ConfirmationConfig } from './step3-confirmation/step3-confirmation.config';

@Component({
	selector: 'sh-add-devices-dialog',
	standalone: true,
	imports: [
		CommonModule,
		TranslocoModule,
		FormsModule,
		PrismStepperComponent,
		PrismStepperDialogComponent,
		StepRouterContentOutletComponent,
		StepRouterFooterOutletComponent
	],
	templateUrl: './add-devices-dialog.component.html',
	styleUrl: './add-devices-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		AddDevicesDialogService,
		...provideStepRouter({
			steps: [Step1HowToFindConfig, Step2DiscoverDevicesConfig, Step3ConfirmationConfig]
		})
	]
})
export class AddDevicesDialogComponent implements AfterViewInit, OnDestroy {
	private readonly stepper = viewChild<PrismStepper>('stepper');

	constructor(
		public readonly dialogRef: PrismDialogRef<AddDevicesDialogComponent>,
		public readonly addDevicesDialogService: AddDevicesDialogService,
		public readonly deviceClaimingService: DeviceClaimingApiService,
		private readonly qrCodeClaimingService: QrCodeClaimingService,
		private readonly stepRouter: StepRouter
	) {}

	public ngAfterViewInit(): void {
		const stepper = this.stepper();
		if (!stepper) {
			throw new Error('Unable to get instance of PrismStepper');
		}

		this.stepRouter.setStepper(stepper);

		const goToQrClaimingStep = this.qrCodeClaimingService.readGoToQrClaimingStepFlag();
		if (goToQrClaimingStep) {
			this.addDevicesDialogService.setClaimByQrCode();
			setTimeout(() => {
				this.stepRouter.nextStep();
			});
		}
	}

	public ngOnDestroy(): void {
		this.qrCodeClaimingService.clear();
	}
}
